import {validateRequired} from "./ValidationFunctions";

export const taskAddCommentForm = {
  fields: {
    date: {
      type: 'date',
      label: 'Date',
      placeholder: 'Date',
      rules: [validateRequired('Date')]
    },
    comment: {
      type: 'textarea',
      label: 'Reference material',
      rules: [validateRequired('Comment')]
    },
  }
}
